import { BrowserRouter as Router, Switch, Route} from "react-router-dom";
import Index from "./Pages/Index";
import Menu from "./Pages/Menu";
import Gallery from "./Pages/Gallery";

function App() {
  return (
    <Router>  
      <Switch>   
        <Route path='/' component={Index} exact />
        <Route path='/menu' component={Menu} exact />
        <Route path='/gallery' component={Gallery} exact />
      </Switch>
    </Router>
  );
}

export default App;
